<template>
    <div v-if="details == false" v-on:click.stop="selectOutcome(outcome)" class="odd-value"
        :class="{'is-selected': isOutcomeSelected, 'is-blocked': outcome.status == 'block', 'no-odd': (outcome.value == '-')}">
      <div class="odd-head" v-if="outcome.value != '-'">
          {{outcomeName
          | formatModifierName(match, outcome.specifiers)}}
        </div>
      <div class="odd-number">
        <div class="odd-change" :class="{'odd-up' : up, 'odd-down': down}"></div>
        {{outcome.value | formatOdd}}
      </div>
    </div>
    <div v-else class="sgame-odd" v-on:click="selectOutcome(outcome)">
        <div class="sgame-odd-header">
            {{outcomeName
            | formatModifierName(match, outcome.specifiers)}}
        </div>
        <div class="sgame-odd-value" :class="{'is-selected': isOutcomeSelected, 'is-blocked': (match.status == 'active' && outcome.status == 'block')}">
          <div class="odd-change" :class="{'odd-up' : up, 'odd-down': down}"></div>
          {{outcome.value | formatOdd}}
        </div>
    </div>
</template>

<script>
import
{
    mapActions,
    mapGetters,
}
from 'vuex';

import { Common } from '@om-retail/vue-common';

export default
{
    name: 'Outcome',
    props: ['outcome', 'match', 'details'],
    data()
    {
        return {
            up: false,
            down: false,
            deselected: false,
        };
    },
    methods:
    {
        ...mapActions([
            'selectBetslipOutcome',
        ]),
        selectOutcome(outcome)
        {
            const me = this;
            if (me.match.status !== 'active' || outcome.status !== 'active' || outcome.value === '-')
            {
                return;
            }

            if (me.isOutcomeSelected)
            {
                me.deselected = true;
            }

            /* const outcomeOut = {
                ...outcome,
                name: me.sportTree.outcomes[me.outcome.outcomeId].name,
                shortName: me.sportTree.outcomes[me.outcome.outcomeId].shortName,
            }; */

            let statusOut = this.match.status;

            if (statusOut === 'active'
            && outcome.status !== statusOut)
            {
                statusOut = outcome.status;
            }

            this.selectBetslipOutcome({
                eventId: this.match.matchId,
                code: this.match.code,
                eventDate: this.match.matchDate,
                eventName: `${this.match.teamNameOne} - ${this.match.teamNameTwo}`,
                selected: true,
                fix: false,
                type: 'sport',
                meta:
                {
                    marketId: outcome.markets[0],
                    sportId: this.match.sportId,
                    categoryId: this.match.categoryId,
                    tournamentId: this.match.tournamentId,
                    outcomeName: Common.formatModifierName(
                        this.sportTree.outcomes[outcome.outcomeId].name,
                        this.match,
                        outcome.specifiers,
                    ),
                    outcomeShortName: this.sportTree.outcomes[outcome.outcomeId].shortName,
                    marketName: Common.formatModifierName(
                        this.sportTree.markets[outcome.markets[0]].name,
                        this.match,
                        outcome.specifiers,
                    ),
                    marketShortName: this.sportTree.markets[outcome.markets[0]].shortName,
                    coefficient: outcome.value,
                    outcomeTags: (outcome.tags !== undefined && outcome.tags !== null)
                        ? outcome.tags.split(',') : [],
                    specifiers: outcome.specifiers,
                    specHash: outcome.specHash,
                    outcomeId: outcome.outcomeId,
                    outcomeHash: outcome.outcomeHash,
                    hasModifier: this.sportTree.markets[outcome.markets[0]].hasModifier,
                    modifierValue: Common.formatModifierName(
                        this.sportTree.markets[outcome.markets[0]].modifierValue,
                        this.match,
                        outcome.specifiers,
                    ),
                    modifierName: this.sportTree.markets[outcome.markets[0]].modifierName,
                    live: (this.match.state === 'live'),
                },
                status: statusOut,
                restrictions: this.match.restrictions,
            });

            /* me.selectEvent(
                {
                    outcome: outcomeOut,
                    match: me.match,
                    type: 'sport',
                },

            ); */

            if (me.timeoutClass !== false)
            {
                clearTimeout(me.timeoutClass);
            }

            me.timeoutClass = setTimeout(() =>
            {
                me.deselected = false;
            }, 1500);
        },
    },
    computed:
    {
        ...mapGetters(
            [
                'sportTree',
                'betslipItemsMapping',
                'globals',
            ],
        ),
        outcomeName()
        {
            const me = this;

            let field = 'name';
            let configName = 'mainGridSelectionsOutcome';

            if (me.details)
            {
                configName = 'matchDetailsOutcome';
            }

            if (me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings[configName] != null)
            {
                field = me.globals.publicConfig.website.sportOfferMarketOutcomeSettings[configName];
            }

            if (me.sportTree.outcomes != null && me.sportTree.outcomes[me.outcome.outcomeId] != null
            && me.sportTree.outcomes[me.outcome.outcomeId][field] != null)
            {
                return me.sportTree.outcomes[me.outcome.outcomeId][field];
            }

            if (me.sportTree.outcomes != null && me.sportTree.outcomes[me.outcome.outcomeId].name !== undefined)
            {
                return me.sportTree.outcomes[me.outcome.outcomeId].name;
            }

            return me.outcome.name;
        },
        isOutcomeSelected()
        {
            const selectionKey = `sport_${this.match.matchId}_${this.outcome.outcomeHash}`;

            if (this.betslipItemsMapping[selectionKey] != null)
            {
                return true;
            }

            return false;
            /* const me = this;

            if (!me.ticket)
            {
                return false;
            }
            if (me.outcome.value === '-')
            {
                return false;
            }

            for (const item of me.ticket.items)
            {
                if (item.selected
                && item.type === 'sport'
                && item.meta != null
                && item.eventId === me.match.matchId
                && item.meta.outcomeId === me.outcome.outcomeId
                && item.meta.outcomeHash === me.outcome.outcomeHash)
                {
                    return true;
                }
            }

            return false; */
        },
    },
    watch:
    {
        outcome(newVal, oldVal)
        {
            const me = this;
            const number = newVal.value;
            const oldNumber = oldVal.value;
            let statusChangeOnly = false;

            if (oldNumber === number)
            {
                if (newVal.status !== oldVal.status)
                {
                    statusChangeOnly = true;
                }
                else
                {
                    return;
                }
            }

            if (!statusChangeOnly)
            {
                me.up = (oldNumber < number);
                me.down = (oldNumber > number);

                if (me.timeout !== false)
                {
                    clearTimeout(me.timeout);
                }

                me.timeout = setTimeout(() =>
                {
                    me.up = false;
                    me.down = false;
                }, 1500);
            }

            // TODO remove, as this won't be used. It will be handled exclusively via socket subscription
            /* if (me.isOutcomeSelected)
            {
                const {
                    match,
                } = me;

                let { status } = newVal;

                if (status === 'active'
                && match.status !== 'active')
                {
                    status = match.status;
                }

                me.ticket.updateEventChangePendingList({
                    items:
                    [
                        {
                            item:
                            {
                                eventId: match.matchId,
                                eventName: `${match.teamNameOne} - ${match.teamNameTwo}`,
                                meta:
                                {
                                    outcomeId: newVal.outcomeId,
                                    marketId: newVal.markets[0],
                                    specHash: newVal.specHash,
                                },
                            },
                            coefficient: newVal.value,
                            status,
                        },
                    ],
                });
            } */
        },
    },
};
</script>
